<template>
  <div class="destination-list-regions filter">
    <ul
      role="tablist"
      class="filter-items"
      :aria-label="tc('booking.accessibility.filterByRegion')"
    >
      <li role="presentation" class="filter-item" :class="[{ active: selectedRegion === null }]">
        <a
          href="#"
          class="tab-group-button"
          id="all-regions"
          role="tab"
          :aria-selected="selectedRegion === null"
          :tabindex="selectedRegion === null ? '0' : '-1'"
          @click.prevent="triggerFilter(null, $event)"
          @keydown.space.prevent="triggerFilter(null, $event)"
          @keydown.left.prevent="triggerFilter(getRegionByIndex(regionsOptions.length - 1), $event)"
          @keydown.right.prevent="triggerFilter(getRegionByIndex(0), $event)"
        >
          {{ tc('booking.allRegions') }}
        </a>
      </li>

      <li
        v-for="(region, i) in regionsOptions"
        :key="i"
        class="filter-item"
        role="presentation"
        :class="[{ active: selectedRegion === region }]"
      >
        <a
          href="#"
          class="tab-group-button"
          :id="'region-' + i"
          role="tab"
          :aria-selected="selectedRegion === region"
          :tabindex="selectedRegion === region ? '0' : '-1'"
          @click.prevent="triggerFilter(region, $event)"
          @keydown.space.prevent="triggerFilter(region, $event)"
          @keydown.left.prevent="triggerFilter(getRegionByIndex(i - 1), $event)"
          @keydown.right.prevent="triggerFilter(getRegionByIndex(i + 1), $event)"
        >
          {{ region }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'destination-list-regions',
    props: {
      regionsOptions: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      selectedRegion: null
    }),
    computed: {
      ...mapGetters('i18n', ['tc'])
    },
    methods: {
      triggerFilter(region, event) {
        event.preventDefault()
        if (this.selectedRegion === region) return
        this.selectedRegion = region
        const regionIndex = this.regionsOptions.indexOf(region)
        const elementId = region ? `region-${regionIndex}` : 'all-regions'
        console.log(elementId)
        this.$el.querySelector(`#${elementId}`).focus()
        this.$emit('filter-items', region, 'tab')
      },
      getRegionByIndex(index) {
        if (index === -1 || index > this.regionsOptions.length - 1) {
          return null
        }
        return this.regionsOptions[index]
      }
    }
  }
</script>
